import React from "react"

import styles from "./h2.less"

const h2 = (props) => {
  return (
    <h2 {...props} className={styles.h2}>
      {props.children}
    </h2>
  )
}

h2.propTypes = {}
h2.defaultProps = {}

export default h2
